export default __webpack_public_path__ + "static/media/resort-189098379e949d69d382dcee51633865.png";